import React from 'react';
import AbstractIcon from 'icons/AbstractIcon';

import { ReactComponent as Icon } from './down-icon.svg';

const DownIcon = (props) => <AbstractIcon {...props} renderIcon={(prps) => <Icon {...prps} />} />;

export default DownIcon;
